document.addEventListener("DOMContentLoaded", function () {


// 🔥 Open Procuret link in new tab
const links = document.querySelectorAll('a[href="https://procuret.com/b?s=XZE"]');

links.forEach(link => {
  link.setAttribute("target", "_blank");
  link.setAttribute("rel", "noopener");
});  
  

  if (window.innerWidth > 767) return;

  const sections = document.querySelectorAll('.pay-perfer');

  sections.forEach(section => {

    const container = section.querySelector('.m-custom-content__wrapper');
    const slides = section.querySelectorAll('.pay-insimg');

    if (!container || slides.length === 0) return;

    let current = 0;
    let interval;

    // 🔥 Create dots
    const dotsWrap = document.createElement('div');
    dotsWrap.className = 'pay-dots';

    slides.forEach((_, i) => {
      const dot = document.createElement('span');
      dot.className = 'pay-dot';
      if (i === 0) dot.classList.add('active');

      dot.addEventListener('click', () => {
        current = i;
        updateSlider();
      });

      dotsWrap.appendChild(dot);
    });

    section.appendChild(dotsWrap);

    const dots = dotsWrap.querySelectorAll('.pay-dot');

    function updateSlider() {
      container.style.transform = `translateX(-${current * 100}%)`;

      dots.forEach(d => d.classList.remove('active'));
      dots[current].classList.add('active');
    }

    function autoSlide() {
      current++;
      if (current >= slides.length) current = 0;
      updateSlider();
    }

    function startAuto() {
      interval = setInterval(autoSlide, 5000);
    }

    function stopAuto() {
      clearInterval(interval);
    }

    startAuto();

    // 🔥 TOUCH SWIPE
    let startX = 0;
    let endX = 0;

    container.addEventListener("touchstart", function (e) {
      startX = e.touches[0].clientX;
      stopAuto();
    });

    container.addEventListener("touchmove", function (e) {
      endX = e.touches[0].clientX;
    });

    container.addEventListener("touchend", function () {

      let diff = startX - endX;

      if (Math.abs(diff) > 50) {

        if (diff > 0) {
          current++;
          if (current >= slides.length) current = 0;
        } else {
          current--;
          if (current < 0) current = slides.length - 1;
        }

        updateSlider();
      }

      startAuto();

    });

  });

});



